// Position and Duties Variables
export const POSITION_DUTIES_VARIABLES: Record<string, string> = {
  position: 'Contractor',
  period: 'fixed-term',
  company: 'the Company',
  location: 'remote',
  schedule: 'full-time',
  duties: 'performance of their duties',
};

export const POSITION_DUTIES_OPTIONS: Record<string, string[]> = {
  position: ['Contractor', 'Employee', 'Consultant', 'Producer'],
  period: ['fixed-term', 'indefinite term', 'trial period', 'probationary period'],
  company: ['the Company', 'Acme Corp', 'Client', 'Employer'],
  location: ['remote', 'on-site', 'hybrid'],
  schedule: ['full-time', 'part-time', 'as-needed'],
  duties: [
    'performance of their duties',
    'fulfillment of obligations',
    'delivery of services',
    'scope of responsibilities',
  ],
};

// Compensation Variables
export const COMPENSATION_VARIABLES: Record<string, string> = {
  salary: '$75,000',
  paymentFrequency: 'monthly',
  currency: 'USD',
  benefits: 'health insurance and retirement plan',
};

export const COMPENSATION_OPTIONS: Record<string, string[]> = {
  salary: ['$50,000', '$75,000', '$100,000', '$125,000', '$150,000'],
  paymentFrequency: ['weekly', 'bi-weekly', 'monthly', 'quarterly'],
  currency: ['USD', 'EUR', 'GBP', 'CAD'],
  benefits: [
    'health insurance and retirement plan',
    'health insurance only',
    'retirement plan only',
    'no benefits'
  ],
};

// Termination Variables
export const TERMINATION_VARIABLES: Record<string, string> = {
  noticePeriod: '30 days',
  terminationCause: 'material breach',
  severancePay: 'two weeks salary',
};

export const TERMINATION_OPTIONS: Record<string, string[]> = {
  noticePeriod: ['14 days', '30 days', '60 days', '90 days'],
  terminationCause: ['material breach', 'any reason', 'for cause only'],
  severancePay: ['no severance', 'one week salary', 'two weeks salary', 'one month salary'],
};

// Combined for backward compatibility
export const DEFAULT_VARIABLES: Record<string, string> = {
  ...POSITION_DUTIES_VARIABLES,
  ...COMPENSATION_VARIABLES,
  ...TERMINATION_VARIABLES,
};

export const VARIABLE_OPTIONS: Record<string, string[]> = {
  ...POSITION_DUTIES_OPTIONS,
  ...COMPENSATION_OPTIONS,
  ...TERMINATION_OPTIONS,
};

export interface ContractSection {
  id: string;
  title: string;
  templateParts: Array<string | { var: string }>;
  variables: Record<string, string>;
  variableOptions: Record<string, string[]>;
}

export const CONTRACT_SECTIONS: ContractSection[] = [
  {
    id: 'position-duties',
    title: 'Position and Duties',
    variables: POSITION_DUTIES_VARIABLES,
    variableOptions: POSITION_DUTIES_OPTIONS,
    templateParts: [
      "Employee agrees to serve as ",
      { var: 'position' },
      " during the ",
      { var: 'period' },
      " and to perform duties as assigned by ",
      { var: 'company' },
      ". Employee will work ",
      { var: 'location' },
      " on a ",
      { var: 'schedule' },
      " basis and devote their best efforts to the ",
      { var: 'duties' },
      "."
    ]
  },
  {
    id: 'compensation',
    title: 'Compensation',
    variables: COMPENSATION_VARIABLES,
    variableOptions: COMPENSATION_OPTIONS,
    templateParts: [
      "In consideration for the services provided, ",
      { var: 'company' },
      " will pay Employee a salary of ",
      { var: 'salary' },
      " ",
      { var: 'currency' },
      " to be paid ",
      { var: 'paymentFrequency' },
      ". Employee will also be entitled to ",
      { var: 'benefits' },
      " as outlined in the employee handbook."
    ]
  },
  {
    id: 'termination',
    title: 'Termination',
    variables: TERMINATION_VARIABLES,
    variableOptions: TERMINATION_OPTIONS,
    templateParts: [
      "Either party may terminate this agreement with ",
      { var: 'noticePeriod' },
      " written notice. In case of termination for ",
      { var: 'terminationCause' },
      ", Employee will receive ",
      { var: 'severancePay' },
      " as severance compensation."
    ]
  }
];

// Legacy exports for backward compatibility
export const TEMPLATE_PARTS = CONTRACT_SECTIONS[0].templateParts;
